import colors from 'shared/colors';
import { goalType } from '@/lib/goal/goal-type';
import { optionColor, propertyType } from 'shared/constants.json';
import { rgbaToHex } from 'shared/lib/color';
import { textByLang } from 'shared/lib/language';
import { goalType as type } from '@/constants.json';

export const companyNodeId = 'company';
export const groupByStatus = 'status';
export const groupByProgress = 'progress';

const getGroup = (grouping, goalSettings, goal) => {
  if (grouping === groupByStatus) {
    return Number(goal.properties.find((propertyValue) => propertyValue.property.type === propertyType.status).selectedOptions[0].uid).toString();
  }
  if (grouping === groupByProgress) {
    switch (true) {
      case (goal.calculatedCurrent >= goalSettings.yellowThreshold):
        return optionColor.green;
      case (goal.calculatedCurrent >= goalSettings.redThreshold):
        return optionColor.yellow;
      default:
        return optionColor.red;
    }
  }
  return '';
};

const getSize = (goal) => {
  if (goalType(goal) === type.keyResult) {
    return 35;
  }

  if (goalType(goal) === type.objective) {
    return 70;
  }

  return 20;
};

const reducer = (grouping, goalSettings) => (accumulator, goal) => {
  if (typeof goal.title === 'undefined') {
    return accumulator;
  }

  accumulator.nodes.push({
    title: goal.title,
    label: goal.title,
    id: goal.uid,
    group: getGroup(grouping, goalSettings, goal),
    mass: 3,
    size: getSize(goal),
    fixed: { x: false, y: false },
  });
  goal.parents.forEach((p) => {
    accumulator.edges.push({
      id: `${goal.uid}:belongs_to:${p.uid}`,
      from: goal.uid,
      to: p.uid,
      length: 10,
      color: { color: rgbaToHex(colors.grey.base) },
      title: 'belongs to',
      arrows: { to: { enabled: true } },
    });
  });
  if (goal.parents.length === 0) {
    accumulator.edges.push({
      id: `${goal.uid}:belongs_to:${companyNodeId}`,
      from: goal.uid,
      to: companyNodeId,
      length: 10,
      color: { color: rgbaToHex(colors.grey.base) },
      title: 'belongs to',
      arrows: { to: { enabled: true } },
    });
  }

  const propEdges = goal.properties.filter((propertyValue) => propertyValue.property.type !== propertyType.status).reduce((acc, prop) => {
    if ([propertyType.options, propertyType.singleSelect].includes(prop.property.type)) {
      acc.push(...prop.selectedOptions.map((option) => ({
        id: `${goal.uid}:belongs_to:${option.uid}`,
        from: goal.uid,
        to: `option_${option.uid}`,
        length: 10,
        color: { color: rgbaToHex(colors.grey.lighten2) },
        title: 'belongs to',
        arrows: { to: { enabled: false } },
        dashes: true,
      })));
    }
    if ([propertyType.space].includes(prop.property.type)) {
      acc.push(...prop.spaces.map((space) => ({
        id: `${goal.uid}:belongs_to:${space.uid}`,
        from: goal.uid,
        to: `space_${space.uid}`,
        length: 10,
        color: { color: rgbaToHex(colors.grey.lighten2) },
        title: 'belongs to',
        arrows: { to: { enabled: false } },
        dashes: true,
      })));
    }
    return acc;
  }, []);
  accumulator.edges.push(...propEdges);

  return accumulator;
};

export const visifyGoals = (goals, account, grouping, goalSettings, props, spaces, userLang) => {
  const res = goals.reduce(reducer(grouping, goalSettings), { nodes: [], edges: [] });

  res.nodes.unshift({
    title: typeof account.accountSettings !== 'undefined' && account.accountSettings.vision !== '' ? account.accountSettings.vision : account.companyName,
    label: typeof account.accountSettings !== 'undefined' && account.accountSettings.vision !== '' ? account.accountSettings.vision : account.companyName,
    id: companyNodeId,
    group: 'company',
    mass: 5,
    x: 0,
    y: 0,
    size: 120,
    fixed: { x: true, y: true },
  });

  const propNodes = props.reduce((acc, prop) => {
    if (prop.isDirect) {
      return acc;
    }

    if (!prop.show) {
      return acc;
    }

    if ([propertyType.options, propertyType.singleSelect].includes(prop.property.type)) {
      acc.push(...prop.property.options.map((option) => ({
        title: textByLang(option.label, userLang),
        label: textByLang(option.label, userLang),
        id: `option_${option.uid}`,
        group: 'company',
        mass: 2,
        size: 40,
      })));
    }
    if ([propertyType.space].includes(prop.property.type)) {
      acc.push(...spaces.map((space) => ({
        title: space.title,
        label: space.title,
        id: `space_${space.uid}`,
        group: 'company',
        mass: 2,
        size: 40,
      })));
    }

    return acc;
  }, []);

  res.nodes.push(...propNodes);
  return res;
};
